import { apiClient } from "@/lib/apiClient";
import { CreateDomainDto, UpdateDomainDto } from "@/types/models/domain";

export const domainService = {
  async getDomains(params: { page?: number; limit?: number } = {}) {
    const apiParams: Record<string, string> = {};

    if (params.page) apiParams.page = params.page.toString();
    if (params.limit) apiParams.limit = params.limit.toString();

    return await apiClient.getPaginated(
      "/api/v1/admin/:storeId/settings/domains",
      apiParams,
    );
  },

  async getDomain(id: string) {
    return await apiClient.get(`/api/v1/admin/:storeId/settings/domains/${id}`);
  },

  async createDomain(data: CreateDomainDto) {
    return await apiClient.post(
      "/api/v1/admin/:storeId/settings/domains",
      data,
    );
  },

  async updateDomain(id: string, data: UpdateDomainDto) {
    return await apiClient.put(
      `/api/v1/admin/:storeId/settings/domains/${id}`,
      data,
    );
  },

  async deleteDomain(id: string) {
    return await apiClient.delete(
      `/api/v1/admin/:storeId/settings/domains/${id}`,
    );
  },
};
